<template>
	<div>
		<headdv :headTitle="headTitle" :isBackShow="true" :goPath="goPatHead" :activeWebTitle = 'activeWebTitle'></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
			<div class="content_dv_dv">
				<headdv2 
					@tapAddFun="addManager" 
					@SearchFun="SearchFun" 
					@allDelFun="allDelFun"  
					@condition1="condition1" 
					@condition3="condition3" 
					
					@condition9="condition9"
					@tapRecommendFun="condition6"
					@searClassFun="searClassFun"
					@condition11="condition11"
					@tapTime2Fun="tapTime2Fun"
					:headData="headData" 
					:dataClassify="dataClassify">
				</headdv2>
				<div class="content">
					<el-table :data="accountList" header-row-class-name="headrow" style="width: 100%" @selection-change="handleSelectionChange" v-loading="loading">
						<el-table-column type="selection" width="55"></el-table-column>
						<!-- <el-table-column type="index" label="#"></el-table-column> -->
						<el-table-column type="id" label="id" prop="id"></el-table-column>
						<el-table-column prop="cdn_path" label="展示" width="100">
							<template slot-scope="scope">
								<!-- <img :src="scope.row.http_path" alt style="width: 40px;height: 40px" /> -->
								<el-image 
									style="width: 40px;height: 40px"
									:src="scope.row.http_path" 
									:preview-src-list="srcList">
								</el-image>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="cdn_path" label="NPM加密展示" width="100">
							<template slot-scope="scope">
								<el-image 
									style="width: 40px;height: 40px"
									:src="scope.row.enc_path_base64"
									:preview-src-list="srcList">
								</el-image>
							</template>
						</el-table-column> -->

						<el-table-column prop="enc_path_base64" label="cf加密图" width="100">
							<template slot-scope="scope">
								<el-image 
									style="width: 40px;height: 40px"
									:src="scope.row.enc_path_base64"
									:preview-src-list="srcList">
								</el-image>
							</template>
						</el-table-column>

						<el-table-column prop="title" label="标题" min-width="200" height="80" show-overflow-tooltip></el-table-column>
						
						<el-table-column prop="classid" label="分类" width="80" :formatter="formatter_class_name"></el-table-column>

						<el-table-column prop="cdn_path" label="cdn" min-width="200" show-overflow-tooltip></el-table-column>

						<el-table-column prop="cf_path" label="cf" min-width="200" show-overflow-tooltip></el-table-column>

						<el-table-column prop="http_path" label="直连" min-width="200" show-overflow-tooltip></el-table-column>

												
						<!-- <el-table-column prop="is_deleted" label="是否下架" width="100" :formatter="formatter_is_deleted"></el-table-column> -->
						<!-- <el-table-column prop="status" label="图片状态" width="100" :formatter="formatter_n_serial_status"></el-table-column> -->

                        <el-table-column prop="remarks" label="备注" min-width="180" show-overflow-tooltip></el-table-column>
						
						<el-table-column label="操作"  width="150" fixed="right">
							<template slot-scope="scope">
								<div style="cursor: pointer;">
									<!-- <div style="color:#409EFF" v-clipboard:copy="scope.row.cdn_path"
										v-clipboard:success="onCopy"
										v-clipboard:error="onError">
										复制cdn
									</div> -->
									<div style="color:#409EFF" v-clipboard:copy="scope.row.cf_path"
										v-clipboard:success="onCopy"
										v-clipboard:error="onError">
										复制cf
									</div>
									<div style="color:#409EFF" v-clipboard:copy="scope.row.http_path"
										v-clipboard:success="onCopy"
										v-clipboard:error="onError">
										复制直连
									</div>
									<div style="color:#409EFF" v-clipboard:copy="scope.row.enc_path_cp"
										v-clipboard:success="onCopy"
										v-clipboard:error="onError">
										复制cf加密
									</div>
								</div>
								
								<div style="margin-left:20px;cursor: pointer;">
									<div @click="downEnc(scope.row)" style="color:#409EFF">下载</div>
									<div @click="editTangChuan(scope.row)" style="color:#409EFF">编辑</div>
									<div @click="handleDeleteClick(scope.row)" style="color:red">删除</div>
									<!-- <el-button	class="edit"	size="small"	type="text"	icon="iconfont icon-zhongxinshuru"	@click="downEnc(scope.row)"	>下载</el-button>
									<el-button	class="edit"	size="small"	type="text"	icon="iconfont icon-zhongxinshuru"	@click="editTangChuan(scope.row)"	>编辑</el-button>
									<el-button size="small"	type="text"	icon="iconfont icon-qingchujiaose"	@click.native.prevent="handleDeleteClick(scope.row)"	>删除</el-button> -->
								</div>
								
							</template>
						</el-table-column>
					</el-table>
				</div>
				
				<!--分页-->
            	<page :pageData="pageData" @changeSizeFun="handleSizeChange" @changeCurrentFun="handleCurrentChange"></page>
			</div>
		</div>
		<!-- 底部 -->
		<footerdv></footerdv>
		<!-- 编辑/添加 -->
		<el-dialog :visible.sync="dialogVisible" width="920px" class="dialog" :close-on-click-modal="false">
			<div class="dialog-title" slot="title">{{isEditOrAdd?'修改':'添加'}}</div>
			<!-- 内容区 start-->
			<el-form ref="staffForm" :rules="rules" :model="staffForm" label-width="100px">
				<el-form-item label="标题:" prop="title">
					<el-input v-model="staffForm.title" placeholder="请输入标题"></el-input>
				</el-form-item>
				
				<el-form-item label="图片:" prop="path">
					<el-input v-model="staffForm.path" placeholder="请上传图片"></el-input>
				</el-form-item>
				<!-- <el-form-item label="cdn链接:" prop="http_path">
					<el-input v-model="staffForm.http_path" placeholder="请输上传封面" ></el-input>
				</el-form-item>-->
				<el-form-item label="加密地址" prop="enc_path">
					<el-input v-model="staffForm.enc_path" placeholder="请输上传封面"></el-input>
				</el-form-item> 

                <el-form-item label="备注:" prop="remarks">
					<el-input v-model="staffForm.remarks" placeholder="请输入备注"></el-input>
				</el-form-item>

                
				
				<el-form-item label="分类:" prop="classid">
					<template>
						<el-select v-model="staffForm.classid" placeholder="请选择" >
						<el-option v-for="item in dataClassify" :key="item.id" :label="item.name" :value="item.id">
							<span style="float: left">{{ item.name }}</span>
						</el-option>
						</el-select>
					</template>
				</el-form-item>
				
				<!-- <el-form-item label="状态：" prop="status">
					<el-switch v-model="staffForm.status" inactive-text="正常" active-text="异常" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item> -->

				<el-form-item prop="filePic" class="shipin_tuoru-kk">
                    <el-upload class="upload-demo" multiple name="file" drag ref="upload" action="string"
                        :on-change="handlechange_filePic" :file-list="fileList" :auto-upload="false"                  
                        :limit="1"
                        :on-remove="handleRemove_filePic" list-type="text">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将要
                            <em>上传的图片</em>拖到此处，或
                            <em>点击此处从文件里选择</em>
                        </div>
                        <div class="el-upload__text">
                            <em>封面文件必须拖入框框内</em>
                        </div>
                    </el-upload>
                </el-form-item>  
				<el-form-item label="上传进度:" prop="ac_force_update">
					<el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
					<p class="percentageStatus">{{percentageStatus}}</p>
				</el-form-item>
				
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="sendRequest" type="danger">点击上传</el-button>  
				<el-button @click="resetForm('staffForm')">取 消</el-button>
				<el-button type="primary" @click="saveForm('staffForm')">保 存</el-button>
			</span>
		</el-dialog>

		<!-- 批量修改 -->
		<el-dialog :visible.sync="statusVisible" width="650px" class="dialog">
			<div class="dialog-title" slot="title">批量上修改：</div>
			<!-- 内容区 start-->
			<el-form   label-width="100px">
				<el-form-item label="上下架：" prop="u_status">
					<el-switch v-model="u_status" inactive-text="下架" active-text="上架" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item>
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="statusVisible=false">取 消</el-button>
				<el-button type="primary" @click="updataStatus()">保 存</el-button>
			</span>
		</el-dialog>
		
		<!-- 删除 -->
		<el-dialog :visible.sync="delDate.status" width="400px" class="dialog">
			<div class="dialog-title" slot="title">删除</div>
			<!-- 内容区 start-->
			<span>确定删除?</span>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="delDate.status=false">取 消</el-button>
				<el-button type="primary" @click="allDeleteEvent">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			loading:true,
			srcList: [
			
			],
			// 新富文本编辑器
			isClear: false,
				editor: {
				info: "",
			},
			headData:{
				search_placeholder:'请输入搜索内容',
				add:true,
				search:true,
				del:false,
				condition1:false,
				condition2:false,
				condition3:true,
				condition4:false,
				condition5:false,
				condition6:false,
				condition8:false,
				condition9:false,
				condition11:false,
			},
			screenHeight: document.documentElement.clientHeight ,// 屏幕高度
			activeWebTitle:'设置',
			//分页
			pageData: {
				pagecount: 1, //总页数  ,默认1
				pagesize: 7, //每页多少条  默认10
				pageindex: 1, //当前页  默认1
				count: 1,
			},
			u_reboot:0, //是否为机器用户 0否 1是
			u_status:0, //批量上下架     0:下架 1:上架
			multipleSelection: [],      //操作多选的数据---   左边勾选的框都会显示在这个数组中
			statusVisible:false,
			delarr: [], //存放删除的数据
			//删除弹窗
			delDate: {
				title: "删除账号",
				label: "删除数据不可恢复，确定删除？",
				status: false,
			},
			//分组id
			problemArrId_type: [],
			accountList: [], //列表数据
			checkedList: [], //选中的绑定值
			headTitle: "员工管理",
			goPatHead: "settings",
			dialogVisible: false,   //开启验证
			isEditOrAdd: false, //判断是添加还是编辑，true为编辑/false为添加
            //修改编辑的数据
			staffForm: {
				id:'',
				title: "",
				classid: "",
				//status: '1',
				path: "",
				http_path: "",
				cdn_path: "",
				enc_path:'',
				remarks: "",
			},
			ldImgName:'',
			//验证规则
			rules: {
				title: [{ required: true, message: "请输入小说标题", trigger: "blur" },],
				classid: [{ required: true, message: "请输选择分类ID", trigger: "blur" }],
				path: [{ required: true, message: "请上传封面地址", trigger: "blur" }],
				status: [{ required: true, message: "请选择连载状态", trigger: "blur" }],
			},
			//分类数据
			dataClassify:[],   
			fileList: [],               //app文件
			percentage:0,              //进度条
			percentageStatus:'准备上传',//上传状态
			searchVal:'',   //搜索
			old_n_manual:'',
			searchData:{
				n_addtime_start:'', //发布开始时间,时间戳
				n_addtime_end:'',   //发布结束时间,时间戳
				order:'id',            //id:默认id;ypv:阅读量倒叙;search_num:搜索量倒叙;fabulous:收藏量倒叙
				is_recommend:'',        //是否推荐;0否 1是
				classid:'',           //分类ID
				status:'',        //更新状态
				is_deleted:'0'     //是否上架;0否 1是
			},
			http_path:'',
			cdn_path:'',
			staticCdnPath:''
		};
	},
	created() {
		this.getWebConfigList()
		
	},
	methods: {
		// 或者封装
		download(href, title) {
			// const a = document.createElement('a');
			// a.setAttribute('href', href);
			// a.setAttribute('download', title);
			// a.click();

			const link = document.createElement('a')
			link.href = href
			link.download = 'image.png'
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)

		},
			downEnc(item){
				console.log(item)
				this.download(item.enc_path_cp || item.http_path,'img')
			},
		onCopy: function (e) {
			//this.$message("复制成功--" +  e.text); 
			this.tc_element('',	'000',	2,	"复制成功");
			// /alert('复制成功: ' + e.text)
		},
		onError: function (e) {
			this.tc_element(e.text,	'999',	2,	"复制失败！");
			//alert('复制失败！')
		},
		//获取配置数据
		getWebConfigList() {
			this.is_ok = false; //控制帅选请求 一个一个来
			var timestamp = Date.parse(new Date());
			let get = `?limit=100&page=${this.pageData.pageindex}&key=${this.searchVal}&v=${timestamp}`;
			this.https(this.apiList.getWebConfigList + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
					let data = response.data.data.data ;
					console.log(data,'datadata')
					data.forEach(item => {
						if(item.conf_code == 'cdn_domain'){
                    		this.cdn_path = item.conf_val ;
						}
						if(item.conf_code == 'zl_domain'){
							this.http_path = item.conf_val ;
						}
						if(item.conf_code == 'cf_domain'){
							this.cf_path = item.conf_val ;
						}
						if(item.conf_code == 'staticCdnPath'){
							this.staticCdnPath = item.conf_val ;
						}
						
					})
					this.getclasslist();
					
				}
			});
		},
		//删除封面
        handleRemove_filePic(file) {
            this.fileList = [];
        },
        //选取要上传的封面后 
        handlechange_filePic(file, fileList) {
            let value = fileList[0];
            this.fileList.push(value.raw);
            this.fileList = fileList;
        },
        //点击添加里更换封面的按钮事件
        sendRequest() {
			
			//先判断 ，如果这个变量为空，说明没有选择本地资源，弹窗提示先选择内容
            if (this.fileList.length == 0) {
                this.$message("文件不能为空，请选择要上传的文件"); 
                return false
            } 
			let _this = this
			let percentageNum = 0
			this.percentageStatus = '正在努力上传中。。'
			let percentageTime = setInterval(() => {
				if(percentageNum<99){
					percentageNum++
					this.percentage = percentageNum
				}else{
					clearInterval(percentageTime)
				}
			},100)
            //上传文件的参数  格式
            let fd = new FormData();
			let imgType = this.fileList[0].raw.type.split('/')[1]

			console.log(imgType)

			if(this.ldImgName.length > 0){
				fd.append("oldImgName", this.ldImgName); 
			}
			fd.append("type", imgType); 
            fd.append("item", 'img');                  //根据接口文档  填写的标识  比如 要上传图片：就是img   视频就是video  联系我们contact  这个得看借口文档
            fd.append("file", this.fileList[0].raw);      //从本地选择好的文件
            //定义好参数后，发送请求，将文件资源发送给服务器，成功后 会返回资源链接
            this.https(this.apiList.upload, fd).then(response => {
                if (response.data.code == this.common.code) {
					this.percentageStatus = '上传成功'
					clearInterval(percentageTime)
					this.percentage = 100
                    this.staffForm.path = response.data.data.path
					this.staffForm.cdn_path = response.data.data.path
					this.staffForm.enc_path = response.data.data.enc_path 
                    this.tc_element(response.data.msg,response.data.code,2,"添加文件")   //成功的提示
                    this.fileList = [];    //完成后 清空数据
					
                }
            })
        },
		change(val) {
		     //this.tgmsg = val;  //这里将获取到的值  赋值给 对应得变量
	    },
		//跳转所有章节
		allChapter(item){
			
			this.$router.push({name:'chapter',query: {id:item.n_id}})
		},
		//批量修改状态  保存
		updataStatus(){
			let ids = ''
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				if(ids == ''){
					ids = this.multipleSelection[i].n_id
				}else{
					ids = ids + ',' + this.multipleSelection[i].n_id
				}
			}
			let fromData = {
				n_id:ids,
				n_status:this.u_status,
			}
			this.https(this.apiList.updatenovel, fromData).then(
				(response) => {
				if (response.data.code == this.common.code){
					this.getTableList();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "批量修改");
				}
				this.statusVisible = false; //隐藏提示框
				}
			);
		},
		//格式化是否推荐
		formatter_n_manual(row, column, cellValue, index) {
			if (cellValue == 1) {
					return "是";
			} else {
					return "否";
			}
		},
		//格式化内容--时间
		formatter_time(row, column, cellValue, index) {
			let time = this.gettime.format(cellValue*1000,3) 
			return time;
		},
		//格式化内容--性别
		formatter_u_sex(row, column, cellValue, index) {
			if (cellValue == 1) {
					return "男";
			} else {
					return "女";
			}
		},
		//格式化内容--是否下架状态 1 下架 0 上架
		formatter_is_deleted(row, column, cellValue, index){
			if (cellValue == 1) {
					return "是";
			} else {
					return "否";
			}
		},
		//格式化内容--连载状态 0 连载中 1 已完结
		formatter_n_serial_status(row, column, cellValue, index){
			if (cellValue == 1) {
					return "已完结";
			} else {
					return "连载中";
			}
		},
		//格式化分类	
		formatter_class_name(row, column, cellValue, index) {
			let result = this.dataClassify.find(ietm => {
				if (cellValue == ietm.id) {
					return ietm;
				}
			})
			return result.name
		},

		
		//返回
		goBack() {
			this.$router.go(-1);
		},
		//获取分类数据
		getclasslist() {
			this.is_ok = false; //控制帅选请求 一个一个来
			var timestamp = Date.parse(new Date());    
			let get = `?limit=${this.pageData.pagesize}&page=${this.pageData.pageindex}&v=${timestamp}`;
			this.https(this.apiList.getimgclasslist + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
                    this.dataClassify = response.data.data.data
					let obj = {
						id:'',
						name:'全部'
					}
					this.dataClassify.push(obj)
					this.getTableList();
				}
			});
		},
		//获取列表数据
		getTableList() {
			this.loading = true
			this.is_ok = false; //控制帅选请求 一个一个来 
			var timestamp = Date.parse(new Date());    
			let get = `?pagesize=${this.pageData.pagesize}\n`+ 
					`&pageindex=${this.pageData.pageindex}\n`+
					`&classid=${this.searchData.classid}\n`+ 
					`&status=${this.searchData.status}\n`+ 
					`&is_deleted=${this.searchData.is_deleted}\n`+ 
					`&is_recommend=${this.searchData.is_recommend}\n`+ 
					`&order=${this.searchData.order}\n`+ 
					`&key=${this.searchVal}\n`+  
					`&v=${timestamp}`  
			this.https(this.apiList.getimglist  + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
					let accountList = response.data.data.data; //列表数据
					this.pageData.pagecount = response.data.data.total_page; //总页数
					this.pageData.count = response.data.data.total; //总条数
					accountList.forEach((item,index) => {
						//let pathObj = this.returnHttpFun(item.classid)
						//this.srcList.push(pathObj.zl_domain+ item.path)
						// item.cdn_path = pathObj.cdn_domain+ item.path
						
						// item.cf_path = pathObj.cf_domain+ item.path
						// item.http_path = pathObj.zl_domain+ item.path
						// item.enc_path = pathObj.cdn_domain+ item.enc_path

						this.srcList.push(this.http_path+ item.path)
						item.http_path = this.http_path+ item.path
						item.cf_path = this.cf_path+ item.path
						item.cdn_path = this.cdn_path+ item.enc_path

						item['enc_path_encry'] = 'encry/'+item.enc_path
						item['enc_path_cp'] = this.cf_path +'encry/' + item.enc_path	
						item['enc_path_base64'] = ''

						// item['enc_path_encry_aly'] = item.enc_path
						// item['enc_path_cp_aly'] = this.cf_path+ item.enc_path	
						// item['enc_path_base64_aly'] = ''

						//加载加密图片
						if(item.enc_path.length > 0){
							// item.enc_path = this.staticCdnPath
							item['enc_path_base'] = this.cf_path + item.enc_path_encry
							this.getBase64ImgFun(item['enc_path_base'],index,1)

							// item['enc_path_base_aly'] = this.cf_path + item.enc_path_encry
							// this.getBase64ImgFun(item['enc_path_base_aly'],index,1)
						}
					})
					this.accountList = accountList
					this.loading = false
				}
			});
		},

		returnHttpFun(class_id){
			let index = this.dataClassify.findIndex((item) => class_id == item.id )
			console.log(index)
			
			if(index !=-1){
				return this.dataClassify[index]
			}
		},

		arrayBufferToBase64(arrayBuffer) {
			const uint8Array = new Uint8Array(arrayBuffer);
			let binary = '';
			uint8Array.forEach((byte) => {
				binary += String.fromCharCode(byte);
			});
			return btoa(binary);
		},
		convertToBase64() {
			this.base64String = this.arrayBufferToBase64(this.arrayBuffer);
		},
		getBase64ImgFun(url,index){
			let timestamp = Date.parse(new Date());
			let that = this
			let imgsrc = url //+'?v='+timestamp
			if(imgsrc.indexOf('encry') >= 0) {
				fetch(imgsrc) 
				.then((response) => response.arrayBuffer())
				.then((buffer) => {
					if(buffer){
						buffer = buffer.slice(17,buffer.length);
						var imageStr = this.arrayBufferToBase64(buffer) 
						let base64Content = `data:image/png;base64,${imageStr}`;
						that.accountList[index].enc_path_base64 = base64Content
						that.srcList[index] = base64Content
					}
				})
				.catch(error => {
					console.log('异步操作失败'+error);
				});
			} else {
				that.accountList[index].enc_path_base64 = imgsrc
				that.srcList[index] = imgsrc
			}

		},
		// 点击添加按钮
		addManager() {
			this.ldImgName = '';
			for(let key in this.staffForm){
				this.staffForm[key] = ''
			}
			this.dialogVisible = true;
			this.isEditOrAdd = false;
		},
		//添加--的确定
		createAccount() {
			let fromData = {}
			for(let key in this.staffForm){
				if(key !='id' || key !='http_path' || key !='cdn_path' || key != 'enc_path'){
					fromData[key] = this.staffForm[key]
				}
			}	
			this.https(this.apiList.addimg, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					this.getTableList();
					for(let key in this.staffForm){
						this.staffForm[key] = ''
					}
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "添加");
				}
				this.dialogVisible = false; //隐藏提示框
				}
			);
		},
		
		//点击编辑事件   显示修改弹窗
		editTangChuan(row) {
			console.log(row,'广告数据')
			this.ldImgName = '';
			this.old_n_manual = row.is_deleted
			this.dialogVisible = true;
			this.isEditOrAdd = true;
			this.ldImgName = this.staffForm.path
			for(let key in this.staffForm){
				this.staffForm[key] = row[key]
			}	
		},
		//编辑弹窗   确定按钮
		createAccount_bianji() {
			let fromData = {}
			for(let key in this.staffForm){
				if( key !='http_path' || key !='cdn_path'){
					fromData[key] = this.staffForm[key]
				}
			}
			
			this.https(this.apiList.updateimg,fromData).then((response) => {
				if (response.data.code == this.common.code) {
					this.getTableList();
					//弹窗提示
					this.tc_element(response.data.msg,	response.data.code,	2,	"编辑");
				}
				this.dialogVisible = false;
			});
		},
		//点击删除按钮  的点击事件
		handleDeleteClick(row) {
			this.delDate.status = true;
			const id = row.id;
			this.delarr.push(id);
		},
		//点击批量删除按钮  的点击事件
		AllDeleteClick(row) {
			this.delDate.status = true;
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				this.delarr.push(this.multipleSelection[i].id);
			}
		},
		//点击删除弹窗的确定按钮
		allDeleteEvent() {
			let fromData = {
				ids : this.delarr[0],
			}
			this.https(this.apiList.deleteimg, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					if (this.accountList.length <= 1) {
					if (this.pageData.pageindex == 1) {
						this.pageData.pageindex = 1;
					} else {
						this.pageData.pageindex--;
					}
					}
					this.getTableList();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "删除数据");
				}
				this.delDate.status = false; //隐藏提示框
				this.delarr = [];
				}
			);
		},
		// 保存
		saveForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// 校验通过
					
					this.dialogVisible = false;
					if (this.isEditOrAdd) {
						//  编辑
						this.createAccount_bianji()
					} else {
						//  添加
						this.createAccount()
					}
				} else {
					//验证失败
					console.log("error submit!!");
					return false;
				}
			});
		},
		//编辑/添加--取消
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false;
		},
		//删除-取消
		deleteRow() {
			this.delDate.status = false;
		},
		

		//头部组件促发的方法
        //添加
        tapAddFun(){
            this.isShowAddForm = true
        },
        //搜索方法
        SearchFun(data){
			this.searchVal = data
			this.getTableList()
        },
        //批量删除
        allDelFun(){
           console.log('del')
        },
        //条件筛选1---批量修改
        condition1(){
			this.statusVisible = true
            console.log('批量修改')
        },
        //条件筛选2
        condition2(){
            console.log('condition2')
        },
        //条件筛选--搜索
        searClassFun(val){
			cosole.log(val)
            this.searchData.classid = val
			this.getTableList()
        },
		//条件筛选3--分类
        condition3(val){
			console.log(val)
            this.searchData.classid = val
			this.getTableList()
        },
        //条件筛选4
        condition4(){
            console.log('condition4')
        },
        //条件筛选5
        condition5(){
            console.log('condition5')
		},
		//是否推荐
		condition6(val){
			this.searchData.is_recommend = val
			this.getTableList()
		},
		//排序
		condition9(val){
			this.searchData.order = val
			this.getTableList()
		},
		//上下架
		condition11(val){
			this.searchData.is_deleted = val
			this.getTableList()
		},
		//时间筛选
		tapTime2Fun(arr){
			this.searchData.n_addtime_start = arr[0]/1000
			this.searchData.n_addtime_end = arr[1]/1000
			this.getTableList()
		},
		
        //分页
		//pageSize 改变时会触发    每页条数
		handleSizeChange(val) {
			console.log(val)
			this.pageData.pagesize = val 
			this.getTableList();
		},
		//currentPage 改变时会触发     当前页
		handleCurrentChange(val) {
			console.log(val)
			this.pageData.pageindex = val
			this.getTableList();
		},
        //取消删除--子组件促发
        cancelDel(){
            this.delDate.status = false;
        },
        //确定删除--子组件促发
        determineDel(){
            //this.allDeleteEvent()
		  },
			//操作多选  --获取多选的内容
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
		  
			//格式化内容--是否会员
			formatter_u_isvip(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "是";
					} else {
						return "否";
					}
			},
			//格式化内容--是否为代理商
			formatter_u_is_agent(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "是";
					} else {
						return "否";
					}
			},
			//格式化内容--是否会员
			formatter_u_status(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "正常";
					} else {
						return "禁用";
					}
			},
	},
};
</script>
<style lang="scss" scoped>
::v-deep .el-textarea .el-textarea__inner {
	min-height: 100px!important;
}
::v-deep .el-textarea{
	width:760px;
}
::v-deep .el-progress {
    margin-top: 7px;
}
.percentageStatus{
	position:absolute;
	left:50%;
	top:50%;
	transform: translate(-50%,-50%);
	color:#ccc;
}
::v-deep .text {
    min-height: 150px;
}
// 表格样式
::v-deep .el-table {
  .headrow,
  .headrow th {
    background-color: #f1f4f5 !important;
  }
  th > .cell {
    color: #555555;
  }
  .cell {
    color: #aaaaaa;
    display: flex;
    // flex-direction: row;
    // align-items: center;
    // justify-content: center;
	max-height: 100px !important;
    line-height: 22px !important;
	
  }
  .el-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #ec808d;
    &.edit {
      color: #4f7da4;
    }
    .iconfont {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}
// 对话框
.dialog {
  .dialog-title {
    width: 100%;
    height: 40px;
    background: #4f7da4;
    line-height: 40px;
    color: #ffffff;
    padding-left: 18px;
    font-size: 14px;
    box-sizing: border-box;
  }
  // 对话框头部
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 7px;
    right: 10px;
    font-size: 24px;
    .el-dialog__close {
      color: #ffffff;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 30px !important;
  }
  // 底部按钮
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  ::v-deep .el-button {
	  margin-left:0px!important;
    width: 128px;
    &.el-button--default {
      background: #f2f2f2;
      color: #aaaaaa;
      border: none;
    }
    &.el-button--primary {
      background: #4f7da4;
      border: none;
    }
    & + .el-button {
      margin-left:0px!important;
    }
  }

  ::v-deep .el-button {
    margin-left: 0px!important;
}
.copy-cdn-btn{
	margin-left: 0px!important;
}
}


</style>
